import Breadcrumb from "../Component/Breadcrumb";
const Withdrawal = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="Withdrawal & Dismissal"
        breadmid="Academic"
        breadend="Withdrawal & Dismissal"
      />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="maintitle">Withdrawal & Dismissal</h2>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/withdrawl.jpg"
                className="img-fluid float-end wid-min"
                alt="Cannosa School Lucknow"
              />
              <ul className="list-view">
                <li>
                  Application for Transfer Certificate should be made in writing
                  to the Principal at least three days in advance by the
                  parent/guardian. T.C. will be issue only after paying all the
                  dues and <span>Rs. 50/-</span> for T.C.{" "}
                </li>
                <li>
                  A student who attends school even for a day in the new
                  Academic Session must deposit one month’s Fee before applying
                  for T.C.{" "}
                </li>
                <li>
                  If a student continues to be absent for 10 working days in
                  succession without applying for leave her/his name will be
                  struck off the Scholar Register and re-admision will be taken,
                  if the parents so wish, on payment of re-admission fees of{" "}
                  <span>Rs. 1000/-</span>.
                </li>
                <li>
                  Application for any certificate shall be made in writing to
                  the Principal, three days in advance. It will be issued at the
                  discretion of the Principal, for which Rs. 50/- will be
                  charged.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Withdrawal;
